module.exports = __webpack_public_path__ + "img/ht.59effc7b.png";